<template>
  <v-sheet>
    <!-- Application Toolbar -->
    <v-toolbar flat height="64">
      <v-btn icon @click="showOverlay()">
        <v-badge
          color="blue"
          overlap
          :value="$store.state.notificationQueue.length > 0"
        >
          <template v-slot:badge>
            <span>{{ $store.state.notificationQueue.length }}</span>
          </template>
          <v-icon large>menu</v-icon>
        </v-badge>
      </v-btn>
      <v-toolbar-title id="toolbar-logo">
        <router-link to="/" v-slot="{ navigate }">
          <div id="project-logo" @click="navigate">
            <img class="pt-2" src="@/assets/inther_bow_small.png" />
            <span id="logo-text">CuS</span>
          </div>
        </router-link>
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>
  </v-sheet>
</template>
<script>
import {EventBus} from "@/lib/event-bus";
import {EVENTBUS_TOPICS} from '@/lib/constants';

export default {
  name: "application-toolbar",
  components: {},
  data() {
    return {
      languages: Object.keys(this.$i18n.messages),
    };
  },
  methods: {
    showOverlay() {
      EventBus.$emit(EVENTBUS_TOPICS.SHOW_OVERLAY, true);
    },
  },
};
</script>
<style scoped>
#toolbar-logo {
  position: relative;
}

#toolbar-logo #logo-text {
  position: absolute;
  font-size: 20pt;
  left: 18px;
  top: 34px;
}

#project-logo {
  cursor: pointer;
}
</style>
